import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Suppress benign "ResizeObserver loop completed with undelivered notifications" errors
// from triggering React's dev error overlay. This warning is harmless and is fired by
// Radix UI components (Select, Popover, etc.) during layout reflows after state changes.
const RESIZE_OBSERVER_ERR = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

window.addEventListener('error', (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e?.reason?.message || String(e?.reason || '');
  if (RESIZE_OBSERVER_ERR.test(msg)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Filter the same noise from console.error so react-error-overlay doesn't pop up
const _originalConsoleError = console.error;
console.error = (...args) => {
  const first = args && args[0];
  const msg = typeof first === 'string' ? first : (first?.message || '');
  if (RESIZE_OBSERVER_ERR.test(msg)) return;
  _originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
